import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

const LOGO = "https://customer-assets.emergentagent.com/job_belajar-usaha/artifacts/9gw0zgjc_icon%20warna.png";

export default function AccessCodeGate({ onVerified }) {
  const { user, setUser } = useAuth();
  const [code, setCode] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Only show for students who haven't verified
  if (!user || user.role !== "student" || user.access_verified) return null;

  const submit = async () => {
    if (!code.trim()) return;
    setLoading(true);
    setError("");
    try {
      await api.post("/me/verify-access", { code: code.trim() });
      setUser(prev => ({ ...prev, access_verified: true }));
      toast.success("Akses berhasil diverifikasi!");
      if (onVerified) onVerified();
    } catch (e) {
      setError(e.response?.data?.detail || "Kode akses salah");
      setCode("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Overlay */}
      <div style={{
        position: "fixed", inset: 0, zIndex: 9999,
        background: "rgba(26,20,34,0.6)",
        backdropFilter: "blur(4px)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: 20,
      }}>
        <div style={{
          background: "#ffffff",
          border: "0.5px solid var(--color-border-tertiary)",
          borderRadius: 20,
          padding: "36px 32px",
          width: "100%", maxWidth: 400,
          boxShadow: "0 24px 60px rgba(0,0,0,0.18)",
          animation: "gateSlideUp .25s ease",
        }}>
          {/* Header: kunci + logo */}
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 22 }}>
            <div style={{
              width: 52, height: 52, borderRadius: 14,
              background: "linear-gradient(135deg,#F3E8FF,#FFF3E0)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 24, flexShrink: 0,
            }}>🔑</div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <img src={LOGO} alt="BisaUsaha" style={{ width: 38, height: 38 }} />
              <div style={{ lineHeight: 1.25 }}>
                <div style={{ fontSize: 16, fontWeight: 800 }}>
                  <span style={{ color: "#FF8C00" }}>Bisa</span>
                  <span style={{ color: "#6B21A8" }}>Usaha</span>
                </div>
                <div style={{ fontSize: 10, color: "var(--color-text-secondary)" }}>karena semua bisa usaha</div>
              </div>
            </div>
          </div>

          <div style={{ fontSize: 20, fontWeight: 700, color: "var(--color-text-primary)", marginBottom: 8 }}>
            Masukkan Kode Akses
          </div>
          <div style={{ fontSize: 14, color: "var(--color-text-secondary)", lineHeight: 1.6, marginBottom: 24 }}>
            Agar bisa mengakses kursus dan dashboard - kode diberikan oleh tim BisaUsaha.
          </div>

          {/* Input */}
          <div style={{ position: "relative", marginBottom: 10 }}>
            <input
              type={show ? "text" : "password"}
              value={code}
              onChange={e => { setCode(e.target.value); setError(""); }}
              onKeyDown={e => e.key === "Enter" && submit()}
              placeholder="Masukkan kode akses..."
              autoFocus
              style={{
                width: "100%", padding: "12px 44px 12px 14px",
                border: `1.5px solid ${error ? "#E24B4A" : "var(--color-border-tertiary)"}`,
                borderRadius: 10,
                background: "var(--color-background-secondary)",
                color: "var(--color-text-primary)",
                fontSize: 15, outline: "none",
                fontFamily: "inherit", letterSpacing: "0.05em",
              }}
            />
            <button
              onClick={() => setShow(s => !s)}
              style={{
                position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
                background: "none", border: "none", cursor: "pointer",
                color: "var(--color-text-secondary)", fontSize: 16, display: "flex", alignItems: "center",
              }}
            >{show ? "🙈" : "👁"}</button>
          </div>

          {error && (
            <div style={{ fontSize: 12, color: "#E24B4A", marginBottom: 12, display: "flex", alignItems: "center", gap: 5 }}>
              <span>⚠</span> {error}
            </div>
          )}

          <button
            onClick={submit}
            disabled={!code.trim() || loading}
            style={{
              width: "100%", padding: 13,
              background: "#6B21A8", color: "#fff",
              border: "none", borderRadius: 10,
              fontSize: 15, fontWeight: 600, fontFamily: "inherit",
              cursor: code.trim() && !loading ? "pointer" : "default",
              opacity: !code.trim() || loading ? 0.5 : 1,
              transition: "opacity .15s",
            }}
          >
            {loading ? "Memverifikasi..." : "Verifikasi Akses"}
          </button>

          <div style={{ textAlign: "center", marginTop: 16, fontSize: 12, color: "var(--color-text-secondary)" }}>
            Belum punya kode akses? Hubungi tim BisaUsaha.
          </div>
        </div>
      </div>

      <style>{`
        @keyframes gateSlideUp {
          from { transform: translateY(16px); opacity: 0; }
          to   { transform: translateY(0); opacity: 1; }
        }
      `}</style>
    </>
  );
}
